import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { Card, CardContent } from '@material-ui/core';
import {
  ScreenContainer, CommonPagination, CommonSearch,
} from '../../CommonComponents';
import CommonButton from '../../CommonComponents/CommonButton';
import {
  getSuppliers, showUserForm, getDashboardSuppliers, createDashSuppliers,
} from '../../redux/actions/suppliers';
import DashUserCreation from '../../CommonComponents/DashUserCreation'
import FallbackCard from '../../CommonComponents/FallbackCard';
import { userTypes } from '../../Utils/constants';
import SupplierUserTable from './SupplierUserTable';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Supplier = ({
  getAllSuppliers,
  allSuppliers,
  createSupplier,
  getUsers,
  userForm,
  showForm,
  totalSupplierUserPages,
}) => {
  const [supplier, setSupplier] = useState(null)
  const history = useHistory()
  const query = useQuery();
  const page = parseInt(query.get('page') || '1', 10);

  useEffect(() => {
    getAllSuppliers();
    if (supplier) { getUsers(page, supplier.supplierId); }
  }, [getUsers, getAllSuppliers, page, supplier]);

  const createUser = (fields) => {
    const data = { ...fields }
    data.depended_field = supplier.supplierId
    data.userType = userTypes.supplier
    createSupplier(data);
  }

  const handleChange = (val) => {
    if (val) {
      const sup = allSuppliers.find((item) => item.id === val.value);
      setSupplier(sup)
      if (sup) {
        history.push('/suppliers')
        getUsers(0, sup.supplierId);
      }
    } else {
      setSupplier(null)
    }
  }

  return (
    <ScreenContainer title="Suppliers">
      <Card>
        <br />
        <CardContent>
          <div className="row">
            {allSuppliers
              ? (
                <div className="col-12">
                  <CommonSearch label="Suppliers" value={supplier} data={allSuppliers} onChange={handleChange} />
                </div>
              )
              : null}
          </div>
        </CardContent>
      </Card>
      <br />
      <div className="row">
        <div className="col-3">
          {supplier
            ? (
              <CommonButton
                variant="outlined"
                color="primary"
                onClick={() => showForm(true)}
              >
                Add User
              </CommonButton>
            )
            : null }
        </div>
      </div>
      <br />
      {supplier
        ? <SupplierUserTable />
        : <FallbackCard text="No data found" /> }
      {totalSupplierUserPages > 1 ? (
        <CommonPagination
          baseUrl="suppliers"
          totalPages={totalSupplierUserPages}
        />
      ) : null}
      {(userForm && supplier)
        ? (
          <DashUserCreation
            userType="supplier"
            setModal={showForm}
            createUser={createUser}
            title={`Add Supplier For :- ${supplier.supplierName}`}
          />
        )
        : null}
    </ScreenContainer>
  );
}

const mapState = (state) => ({
  allSuppliers: state.suppliers.allSuppliers,
  userForm: state.suppliers.showUserForm,
  totalDashSupplierUserPages: state.suppliers.totalDashSupplierUserPages,
});

const mapActions = {
  getAllSuppliers: getSuppliers,
  createSupplier: createDashSuppliers,
  getUsers: getDashboardSuppliers,
  showForm: showUserForm,
};

export default connect(mapState, mapActions)(Supplier);
